module.exports = __webpack_public_path__ + "img/2.1d9a7b5b.jpg";